import { fromRoot, getBase } from "../../../../utils/buildRelatedFields";
import { formStructure } from "../../../../utils/nameFormatter";
import _ from 'lodash';
import { decimalNumFormatter } from "../../../../utils/decimalNumFormatter";
import { dollarsFormatterInput } from "../../../../utils/decimalNumFormatterInput";
import { fromJS } from "immutable";
import { mergeArray, flattenArr } from "../../../../utils/commonUtil";
import { accountDataReceivedType, recommendAnExchangeDataSuccessType } from '../../../../actions/globalActionTypes'
import {
  setPoolModalFalseType,
  recommendAnExchangeFromDataSuccessType,
  updateOneTimeFormFieldsType,
  updateRecurringFormFieldsType,
  enableOnetimeRecommendFromType,
  enableRecurringRecommendFromType,
  updateTabActiveType,
  initializeFromPoolsType,
  initializeToPoolsType,
  updateFromFormFieldType,
  updateToFormFieldType,
  reallocatePoolsType,
  resetFromPoolsType,
  clearFromPoolType,
  updateDollarsTotalType,
  updatePercentageTotalType,
  resetToPoolsType,
  updateActiveConfirmationType,
  toggleInvestmentOptionModalType,
  showUpdateButtonType,
  setOldStateType,
  beforePoolsStateType,
  beforeToPoolStateType,
  switchTabExchangeType,
  setPathFromTIFFType,
  setEndDateWorkerType,
  setNumberOfExchangeType,
  setDateType,
  setPendingPopUpType,
  exitRecommendAnExchangeType,
  setDataClearMessageType,
  setExchangeFlagAndDataType,
  setFromNewPoolsType,
  setToNewPoolsType,
  setexchangePathType,
  setExchangeTypeType,
  enableSteppersType,
  resetEditFlagType,
  setStartDateType,
  setEndDateType,
  setFrequencyType,
  setNumOfExchangesType,
  resetRecurringType,
  resetOneTimeType,
  onExchangeFromType,
  onExchangeToType,
  setRecurringDataType,
  editStepsType,
  fetchCustomPoolFeeSuccessType,
  fetchCustomPoolFeeFailedType
} from './actionTypes'

const initialState = fromJS({
  typeActive: "oneTime",
  activePageStepName: "fromPool",
  switchInvestmentOptionModalVisibility: false,
  activeConfirmation: false,
  startDate: "",
  requestDataOneTime: {
    body: {
      accountId: "84958",
      partyId: "597219",

      exchangeType: "",
      category: "Single Exchange",
      unit: "",
      exchangeFrom: [],
      exchangeTo: []
    }
  },
  accountData: {
    isLoading: true,
    data: {},
    error: ""
  },

  allPoolData: {
    isLoading: true,
    data: {},
    error: ""
  },
  poolData: {
    singlePool: {},
    singleUF: {},
    modalPool: false,
    modalUF: false
  },
  stepper: {
    activeStepNumber: 0
  },
  activeExchangeScheduleCount: 0,
  fromPool: {
    isEnabled: false,
    activeExchangeUnit: "",
    form: {},
    recordedVal: 0,
    total: 0,
    totalDollar: 0,
    edit: false
  },
  clonefromPool: {},
  toPool: {
    isEnabled: false,
    form: {},
    total: 0,
    edit: false
  },
  clonetoPool: {},

  oneTime: {
    exchangeType: ""
  },

  recurring: {
    frequency: "",
    startDate: "",
    numberOfExchanges: "",
    endDate: "",
    exchangeType: "Custom Exchange"
  },
  tiff: {},

  cloneForm: {},
  confirmation: {
    transactionID: -1,
    exchangeSuccess: false
  },
  popUp: {
    exchangeType: false,
    exchangeTypeData: false
  },
  viewExchange: {
    pathFrom: false,
    scheduleType: "",
    isLoading: true,
    fromPool: {},
    toPool: {},
    data: {},
    pathName: ''
  },
  counter: {
    from: 0
  },
  fromReview: {
    edit: false
  },
  tradeDate: {},

  //abhineet
  toFrom: {
    isLoading: true,
    data: [],
    error: ""
  },
  exchangeFromPool: {
    poolData: null,
    activeExchangeUnit: null,
    isStepOneSet: false,
    totalAmount: 0,
    oneTime: {},
    recurring: {},
    edit: false
  },
  exchangeToPool: {
    toPool: null,
    totalPercentage: 0,
    isStepTwoSet: false,
    edit: false
  },
  customFeeForPool: []
});

const recommendAnExchange = (state = initialState, action) => {
  switch (action.type) {

    case fetchCustomPoolFeeSuccessType:
      const { poolFees = [] } = action.payload;
      const poolFeeStructure = poolFees.map(pool => ({
        feeType: pool.feeType,
        feePercent: pool.feePercent
      }));
      return state.set("customFeeForPool", poolFeeStructure);

    case fetchCustomPoolFeeFailedType:
      return state.set("customFeeForPool", [{
        feeType: "",
        feePercent: ""
      }]);

    case accountDataReceivedType:

      return state
        .setIn(["accountData", "data"], action.data)
        .setIn(["allPoolData", "data"], action.data)
        .setIn(
          ["accountData", "isLoading"],
          false
        );

    // TODO: Remove the below block if we are refactoring all other flows
    case recommendAnExchangeDataSuccessType:

      return state
        .setIn(["accountData", "data"], action.payload)
        .setIn(["allPoolData", "data"], action.payload)
        .setIn(
          ["accountData", "isLoading"],
          false
        );

    case recommendAnExchangeFromDataSuccessType:
      return state.setIn(
        ["recommendAnExchangeFrom", "table", "data"],
        action.payload
      );

    case updateOneTimeFormFieldsType: {

      let type = "";
      if (action.payload.value === "Custom Exchange") {
        type = "Custom Exchange";
      } else if (action.payload.value === "Reallocation") {
        type = "Reallocation";
      }
      return state
        .setIn(
          ["oneTime", `${action.payload.name}`],
          action.payload.value
        )
    }

    case updateRecurringFormFieldsType: {
      return state.setIn(
        ["recurring", `${action.payload.name}`],
        action.payload.value
      );
    }

    case enableOnetimeRecommendFromType:
      return state.setIn(["fromPool", "isEnabled"], action.payload);

    case resetRecurringType: {
      return state.setIn(["recurring", "frequency"], "")
        .setIn(["recurring", "startDate"], "")
        .setIn(["recurring", "endDate"], "")
        .setIn(["recurring", "numberOfExchanges"], "")
    }

    case resetOneTimeType: {
      return state.setIn(["oneTime", "exchangeType"], "")
    }

    case enableRecurringRecommendFromType: {

      if (action.payload === false) {
        return state.setIn(["fromPool", "isEnabled"], action.payload)
          .setIn(["fromPool", "activeExchangeUnit"], "")
      } else {
        return state.setIn(["fromPool", "isEnabled"], action.payload);
      }
    }

    case updateTabActiveType:
      return state.set("typeActive", action.payload);

    case "UPDATE_ACTIVE_PAGE_STEP_NAME":
      return state.set("activePageStepName", action.payload);

    case initializeFromPoolsType: {
      const exchangeFromData = state.getIn(["viewExchange", "fromPool"]);
      const check = state.getIn(["viewExchange", "pathFrom"]);
      let newPayload = {}
      if (check) {
        newPayload = _.merge(action.payload, exchangeFromData);
      } else {
        newPayload = action.payload;
      }
      return state.setIn(["fromPool", "form"], newPayload);
    }

    case initializeToPoolsType: {
      const exchangeToData = state.getIn(["viewExchange", "toPool"]);
      const check = state.getIn(["viewExchange", "pathFrom"]);
      let newPayload = {}
      if (check) {
        newPayload = _.merge(action.payload, exchangeToData);
      } else {
        newPayload = action.payload;
      }
      return state.setIn(["toPool", "form"], newPayload);
    }
    case updateFromFormFieldType: {
      const { poolName, stuff, fieldSuffix, val } = action.payload;
      return state
        .updateIn(
          [`${state.get("activePageStepName")}`, "form", `${poolName}`],
          item => ({
            ...item,
            ...(function formatPoolFields() {
              const pool = fromRoot(stuff, getBase(stuff, fieldSuffix, val));
              for (const suffix in pool) {
                pool[suffix] = decimalNumFormatter({
                  suffix,
                  val: pool[suffix]
                });
              }
              if (fieldSuffix !== "Percentage")
                pool["Percentage"] = parseFloat(pool["Percentage"]).toFixed(0);
              pool[fieldSuffix] = val;
              pool["Units"] = parseFloat(pool["Units"]).toFixed(4);
              pool["Dollars"] = parseFloat(pool["Dollars"]).toFixed(2);
              return pool;
            })()
          })
        )
    }

    case updateToFormFieldType: {
      const { poolName, fieldSuffix, val } = action.payload;
      const obj = {
        poolId: "37",
        poolName: poolName,
        value: val
      };
      let testnew = "";
      let test = state.getIn(["requestDataOneTime", "body", "exchangeFrom"]);
      if (test.size === 0) {
        testnew = test.toJS();
      } else {
        testnew = test;
      }
      testnew.push(obj);
      return state
        .updateIn(
          [`${state.get("activePageStepName")}`, "form", `${poolName}`],
          item => ({
            ...item,
            [fieldSuffix]: val
          })
        )
        .setIn(["requestDataOneTime", "body", "exchangeTo"], testnew);
    }

    case resetFromPoolsType: {

      return state
        .updateIn(["fromPool", "form"], item =>
          Object.assign(
            {},
            Object.keys(item).reduce((acc, key) => {
              acc[key] = {};
              return acc;
            }, {})
          )
        )
        .setIn(["fromPool", "total"], 0);
    }
    case resetToPoolsType:
      return state
        .updateIn(["toPool", "form"], item =>
          Object.assign(
            {},
            Object.keys(item).reduce((acc, key) => {
              acc[key] = {};
              return acc;
            }, {})
          )
        )
        .setIn(["toPool", "total"], 0);

    case reallocatePoolsType:
      return state
        .updateIn([`${state.get("activePageStepName")}`, "form"], item => ({
          ...item,
          ...formStructure(
            state.getIn(["accountData", "data"]).investmentPools,
            action.payload
          )
        }))
        .setIn(["fromPool", "total"], 100)

    case clearFromPoolType: {
      let counter = state.getIn(["counter", "from"]);
      const activePage = state.get("activePageStepName");
      const poolName = action.payload;
      if (activePage === "fromPool") {
        let from = state.getIn(["requestDataOneTime", "body", "exchangeFrom"]);
        from.some(function (item, index) {
          if (from[index]["poolName"] === poolName) {
            // found it!
            from.splice(index, 1);
            return true; // stops the loop
          }
          return false;
        });
        if (from.length === 0) {
        }
        return state
          .updateIn(["fromPool", "form", `${poolName}`], () => ({}))
          .setIn(["requestDataOneTime", "body", "exchangeFrom"], from)
          .setIn(['counter', 'from'], counter)
      } else if (activePage === "toPool") {
        let to = state.getIn(["requestDataOneTime", "body", "exchangeTo"]);
        to.some(function (item, index) {
          if (to[index]["poolName"] === poolName) {
            // found it!
            to.splice(index, 1);
            return true; // stops the loop
          }
          return false;
        });
        if (to.length === 0) {
        }
        return state
          .updateIn(["toPool", "form", `${poolName}`], () => ({}))
          .setIn(["requestDataOneTime", "body", "exchangeTo"], to);
      }
    }

    case "SWITCH_EXCHANGE_UNIT": {
      return state
        .setIn(["fromPool", "activeExchangeUnit"], action.payload)
        .setIn(
          ["requestDataOneTime", "body", "unit"],
          action.payload.toUpperCase()
        );
    }
    case "UPDATE_FROM_TOTAL": {
      let counter = state.getIn(["counter", "from"]);
      const { value } = action.payload;
      const recordedVal = state.getIn(["fromPool", "recordedVal"]);
      return state.updateIn(["fromPool", "total"], item => {
        if (value === "reset") return 0;
        if (value) {
          if (value >= 0) {
            counter = counter + 1;
          } else {
            counter = counter - 1;
          }
          return +decimalNumFormatter({
            fieldSuffix: state.getIn(["fromPool", "activeExchangeUnit"]),
            val: item + value
          });
        }
        return item - recordedVal;
      })
        .setIn(["counter", "from"], counter);
    }

    case "UPDATE_RECORDED_VAL":
      return state.setIn(["fromPool", "recordedVal"], action.payload);

    case updateDollarsTotalType:
      return state.updateIn(["fromPool", "totalDollar"], () => {
        const pools = state.getIn(["fromPool", "form"]);

        let total = 0;
        if (pools.size !== 0) {
          for (const pool in pools) {
            if (Object.keys(pools[pool]).length) {
              total = parseFloat(total);
              const addTotal = parseFloat(pools[pool].Dollars);
              total += addTotal;
            }
          }
          return +dollarsFormatterInput(total.toFixed(2));
        } else {
          return +dollarsFormatterInput(total);
        }
      });

    case updatePercentageTotalType: {
      return state.updateIn(["toPool", "total"], () => {
        const pools = state.getIn(["toPool", "form"]);
        let total = 0;
        for (const pool in pools) {
          if (Object.keys(pools[pool]).length) {
            total = parseInt(total, 10);
            const addNumber = parseInt(pools[pool].Percentage, 10);
            total += addNumber;
          }
        }
        return total;
      });
    }
    case "SUBMIT_FORM_SUCCESS_RAE":
      return state
        .setIn(["confirmation", "transactionID"], action.payload)
        .setIn(["confirmation", "exchangeSuccess"], true);

    case updateActiveConfirmationType:
      return state.set("activeConfirmation", true);

    case toggleInvestmentOptionModalType:
      return state.set(
        "switchInvestmentOptionModalVisibility",
        !state.get("switchInvestmentOptionModalVisibility")
      );

    case showUpdateButtonType: {
      return state.setIn([action.payload, "edit"], true)
        .setIn(['fromReview', "edit"], true)
    }

    case setOldStateType: {
      const cloneName = "clone" + action.payload;
      return state.set(cloneName, state.get(action.payload))
        .set("coneForm", "form");
    }
    case beforePoolsStateType: {
      return state
        .setIn(["fromPool", "form"], action.payload.fromPool)
        .setIn(["fromPool", "totalDollar"], action.payload.oldTotal);
    }

    case beforeToPoolStateType: {
      return state.setIn(["toPool", "form"], action.payload);
    }

    case switchTabExchangeType: {
      return state.set("typeActive", action.payload);
    }
    case setEndDateWorkerType: {
      return state.setIn(
        ["recurring", `${action.payload.name}`],
        action.payload.value
      );
    }
    case setDateType: {
      return state.setIn(["startDate"], action.payload);
    }
    case "POOL_DATA_SUCCESS_SET": {
      return state.setIn(["poolData", "modalPool"], action.payload);
    }



    case setPathFromTIFFType: {
      return state.setIn(["viewExchange", "pathFromTIFF"], true);
    }
    case setPendingPopUpType: {
      return state.setIn(["popUp", "exchangeType"], action.payload);
    }
    case setDataClearMessageType: {
      return state.setIn(["popUp", "exchangeTypeData"], action.payload);
    }
    case setFromNewPoolsType: {
      return state.setIn(["viewExchange", "fromPool"], action.payload)
    }
    case setToNewPoolsType: {

      return state.setIn(["viewExchange", "toPool"], action.payload)
    }
    case setExchangeFlagAndDataType: {
      return state.setIn(["viewExchange", "pathFrom"], true)
        .setIn(["viewExchange", "scheduleType"], "Onetime")
        .setIn(["viewExchange", "data"], action.payload)

    }
    case setexchangePathType: {
      return state.setIn(["viewExchange", "pathName"], action.payload)
    }

    case setExchangeTypeType: {
      return state.setIn(["oneTime", "exchangeType"], action.payload)
    }
    case "EXIT_RAE": {
      return state.setIn(["typeActive"], "oneTime")
        .setIn(["activePageStepName"], "fromPool")
        .setIn(["switchInvestmentOptionModalVisibility"], false)
        .setIn(["activeConfirmation"], false)
        .setIn(["startDate"], "")
        .setIn(["accountData", "isLoading"], true)
        .setIn(["accountData", "data"], {})
        .setIn(["accountData", "error"], "")
        .setIn(["toFrom", "isLoading"], true)
        .setIn(["toFrom", "data"], [])
        .setIn(["toFrom", "error"], "")
        .setIn(["allPoolData", "isLoading"], true)
        .setIn(["allPoolData", "data"], {})
        .setIn(["allPoolData", "error"], "")
        .setIn(["poolData", "singlePool"], {})
        .setIn(["poolData", "singleUF"], {})
        .setIn(["poolData", "modalPool"], false)
        .setIn(["poolData", "modalUF"], false)
        .setIn(["stepper", "activeStepNumber"], 0)
        .setIn(["fromPool", "isEnabled"], false)
        .setIn(["fromPool", "activeExchangeUnit"], "")
        .setIn(["fromPool", "form"], {})
        .setIn(["fromPool", "recordedVal"], 0)
        .setIn(["fromPool", "total"], 0)
        .setIn(["fromPool", "totalDollar"], 0)
        .setIn(["fromPool", "edit"], false)
        .setIn(["clonefromPool"], {})
        .setIn(["toPool", "isEnabled"], false)
        .setIn(["toPool", "form"], {})
        .setIn(["toPool", "total"], 0)
        .setIn(["toPool", "edit"], false)
        .setIn(["clonetoPool", "edit"], false)
        .setIn(["oneTime", "exchangeType"], "")
        .setIn(["recurring", "frequency"], "")
        .setIn(["recurring", "startDate"], "")
        .setIn(["recurring", "numberOfExchanges"], "")
        .setIn(["recurring", "endDate"], "")
        .setIn(["recurring", "exchangeType"], "Custom Exchange")
        .setIn(["confirmation", "transactionID"], -1)
        .setIn(["confirmation", "exchangeSuccess"], false)
        .setIn(["popUp", "exchangeType"], false)
        .setIn(["viewExchange", "pathFrom"], false)
        .setIn(["viewExchange", "scheduleType"], "")
        .setIn(["viewExchange", "isLoading"], true)
        .setIn(["viewExchange", "fromPool"], {})
        .setIn(["viewExchange", "toPool"], {})
        .setIn(["viewExchange", "data"], {})
        .setIn(["viewExchange", "pathName"], '')

    }
    case enableSteppersType:
      return state.setIn(["fromReview", "edit"], false);

    case resetEditFlagType:
      return state.setIn(['fromPool', 'edit'], action.payload)
        .setIn(['toPool', 'edit'], action.payload)

    case 'TRADE_DATA_SUCCESS': {
      return state.setIn(['tradeDate'], action.payload)
    }

    case setNumberOfExchangeType: {
      return state.setIn(
        ["recurring", `${action.payload.name}`],
        action.payload.value
      );
    }

    case setStartDateType: {
      return state.setIn(["recurring", "startDate"],
        action.payload
      );
    }
    case setEndDateType: {

      return state.setIn(["recurring", "endDate"],
        action.payload
      );
    }
    case setFrequencyType: {
      return state.setIn(["recurring", "frequency"],
        action.payload
      );
    }
    case setNumOfExchangesType: {
      return state.setIn(["recurring", "numberOfExchanges"],
        action.payload
      );
    }

    //ABHINEET

    case 'SCHEDULE_COUNT_SUCCESS': {
      return state.setIn(['activeExchangeScheduleCount'], action.payload)
    }
    // case "ALL_POOL_DATA_SUCCESS": {
    //   return state.updateIn(["toFrom", "data"], () => {
    //     let investPoolData = state.getIn([
    //       "accountData",
    //       "data",
    //       "investmentPools"
    //     ]);

    //     let allPoolData = flattenArr(action.payload)
    //     return mergeArray(investPoolData, allPoolData)
    //   })
    //     .setIn(["toFrom", "isLoading"], false);
    // }
    case onExchangeFromType:
      return state
        .setIn(["exchangeFromPool", "poolData"], action.payload.poolData)
        .setIn(["exchangeFromPool", "activeExchangeUnit"], action.payload.activeExchangeUnit)
        .setIn(["exchangeFromPool", "totalAmount"], action.payload.totalAmount)
        .setIn(["exchangeFromPool", "oneTime"], action.payload.oneTime)
        .setIn(["exchangeFromPool", "recurring"], action.payload.recurring)
        .setIn(["exchangeFromPool", "isStepOneSet"], true)

    case onExchangeToType:
      return state
        .setIn(["exchangeToPool", "toPool"], action.payload.toPool)
        .setIn(["exchangeToPool", "totalPercentage"], action.payload.totalPercentage)
        .setIn(["exchangeToPool", "isStepTwoSet"], true)

    case setRecurringDataType:
      return state
        .setIn(["exchangeFromPool", "recurring", "numberOfExchanges"], action.payload.numberOfExchanges)
        .setIn(["exchangeFromPool", "recurring", "endDate"], action.payload.endDate)

    case "POOL_DATA_SUCCESS":
      return state.setIn(["poolData", "singlePool"], action.payload);

    case "UNDERLYING_DATA_SUCCESS":
      return state.setIn(["poolData", "singleUF"], action.payload);

    case "UNDERLYING_DATA_SUCCESS_SET": {
      return state.setIn(["poolData", "modalUF"], action.payload);
    }
    case setPoolModalFalseType: {
      return state
        .setIn(["poolData", "modalUF"], action.payload)
        .setIn(["poolData", "modalPool"], action.payload);
    }
    case editStepsType:
      return state
        .setIn([`${action.payload}`, "edit"], true)

    case exitRecommendAnExchangeType:
      return state
        .setIn(["exchangeFromPool", "poolData"], null)
        .setIn(["exchangeFromPool", "activeExchangeUnit"], null)
        .setIn(["exchangeFromPool", "isStepOneSet"], false)
        .setIn(["exchangeFromPool", "totalAmount"], 0)
        .setIn(["exchangeFromPool", "oneTime"], {})
        .setIn(["exchangeFromPool", "recurring"], {})
        .setIn(["exchangeFromPool", "edit"], false)
        .setIn(["exchangeToPool", "toPool"], null)
        .setIn(["exchangeToPool", "totalPercentage"], 0)
        .setIn(["exchangeToPool", "isStepTwoSet"], false)
        .setIn(["exchangeToPool", "edit"], false)

    default:
      return state;
  }
};

export default recommendAnExchange;